import React, { useState } from 'react';
import { MdClose } from "react-icons/md";
import Modal from 'react-responsive-modal';

const FileForwardComment = ({ onClose, isOpen, handleForward, minidiv }) => {
    const [message, setMessage] = useState('');

    const closeIcon = <MdClose className="text-3xl mt-1 text-teal-600 dark:text-white " />;

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            container={document.getElementById('root')}
            center
            closeIcon={closeIcon}
            focusTrapped={false}
            classNames={{
                overlay: 'customOverlay',
                modal: 'customModal',
            }}
        >
            <div className="">
                <h2 className="text-xl font-semibold text-teal-600">
                    Forward message to :
                </h2>
                <div className=''>
                    <div className="flex gap-1.5 flex-wrap items-center pt-6 pb-4">
                        {minidiv}
                        <div className="" >Add/Edit</div>
                    </div>

                    <div className=''>
                        <label className='write_msg_label'>Write a message/comment</label>
                        <div className="secretUserList"></div>
                        <div>
                            <textarea onChange={(e) => setMessage(e.target.value)} className={'border w-full rounded p-3'} name='msg' placeholder='Write a message' />
                        </div>
                    </div>
                </div>

                <div className="flex justify-end gap-2.5 pt-3">
                    <button onClick={onClose} className="px-4 py-2 border border-[#0a256a] text-teal-600 rounded-md">Cancel</button>
                    <button className="px-4 py-2 bg-teal-600 text-white rounded-md" onClick={() => handleForward(message)}>Forward</button>
                </div>
            </div>
        </Modal>
    );
};

export default FileForwardComment;